import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-serice-manager",
  "use": "icon-serice-manager-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-serice-manager\"><path fill=\"currentColor\" d=\"M948.096 75.904V784.64h-327.04v54.464h163.52v109.056H239.36V839.04h163.584v-54.464h-327.04V75.904h872.128z m-599.68 381.568H239.488v109.056h109.056V457.472z m436.16 0H403.008v109.056h381.568V457.472zM348.48 293.952H239.36v109.056h109.056V293.952z m436.096 0H403.008v109.056h381.568V293.952z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol